import * as React from 'react';

// From https://github.com/gregberge/react-merge-refs
export function mergeRefs<T = any>(
  refs: Array<React.MutableRefObject<T> | React.Ref<T> | undefined | null>
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}
